import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { 
  AddReleaseRequest, AddReleaseResponse, CreateTagRequest, CreateTagResponse, ListReleasesRequest, ListReleasesResponse,
  ListTagsRequest,
  ListTagsResponse,
  ProductName, Release, ResourceType, SituViewWebApiClient,
  Tag
} from 'situview-webapi-client';
import { RenameDialogComponent } from 'src/app/components/rename-dialog/rename-dialog.component';
import { AuthService, ProductNameService, StateService } from 'src/app/services';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { TagEditDialogComponent } from '../tag-edit-dialog/tag-edit-dialog.component';

@Component({
  selector: 'tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss']
})
export class TagListComponent extends SituBaseComponent {
  loading: boolean = false;
  data = new MatTableDataSource<Tag>();
  filteredData: Tag[] | undefined;
  productNames = ProductName;
  tagTypes = ResourceType;
 

  /* Filters */
  searchTerm: string = "";
  resourceTypeFilter: ResourceType | undefined;
  /* Filters */

  /* Query Parameters */
  readonly SearchParamName: string = "search";
  readonly TypeParamName: string = "type";
  /* Query Parameters */

  constructor(
    authService: AuthService,
    stateService: StateService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private situViewApiClient: SituViewWebApiClient,
    private dialog: MatDialog,
    private productNameService: ProductNameService
  ) { 
    super(authService, stateService);

    if (this.route.snapshot.queryParams[this.SearchParamName]) {
      this.searchTerm = this.route.snapshot.queryParams[this.SearchParamName];
    }

    if (this.route.snapshot.queryParams[this.TypeParamName]) {
      //this.resourceTypeFilter = true;
    }
  }

  protected onSelectedCompanyChange(): void {
    this.loadData().then(() => {
      this.filterData();
    });
  }

  onClickRelease(item: Release | undefined, dynamicList?: string) {
    if (dynamicList) {
      this.router.navigate(['admin/release', dynamicList]);
    } else if (item) {
      this.router.navigate(['admin/release', item.id]);
    }
  }

  getProductColour(productName: ProductName) {
    return this.productNameService.getProductNameConfiguration(productName as any)?.productColor;
  }

  isExpired(releaseDate: Date) {
    return releaseDate < new Date();
  }

  filterData() {
    this.filteredData = this.data.data.filter(item => {
      const lowerCaseSearch = this.searchTerm.toLowerCase();
        return (item.name?.toLowerCase().includes(lowerCaseSearch) && (this.resourceTypeFilter === undefined || this.resourceTypeFilter === item.resourceType));
    });
    this.updateParams();
  }

  
  setTypeFilter(type: ResourceType | undefined) {
    if (type != this.resourceTypeFilter) {
      this.resourceTypeFilter = type;
    }
    this.filterData();
    // this.loadData().then(() => {
    //     this.filterData();
    //   });
  }

  loadData() {
    this.loading = true;

    let request = new ListTagsRequest();
    request.companyId = this.selectedCompany?.id;
    //request.includeStats = true;
    //f (this.onlyActiveFilter) request.isNotReleased = true;

    return this.situViewApiClient.listTags(request)
      .then((response: ListTagsResponse) => {
        if (response.success) {
          this.data.data = response.tags ?? [];
          this.filteredData = response.tags ?? [];
        } else {
          this.showMessage("There was an issue retrieving releases!");
        }
        this.loading = false;
      })
      .catch((err: any) => {
        this.loading = false;
        this.showMessage("Could not retrieve releases!");
      });
  }

  addTag() {
    const dialogRef = this.dialog.open(TagEditDialogComponent, {
        width: '60%',
        height: '60%',
        hasBackdrop: true,
        disableClose: true,
        data: { 
            existingName: "",
            resourceType: ResourceType.Any
        }
    });

    this._subscriptions.push(dialogRef.afterClosed().subscribe(data => {
        if (data !== undefined) {
            let request = new CreateTagRequest();
            request.companyId = this.selectedCompany?.id;
            request.name = data.newName;
            request.resourceType = data.resourceType;

            this.situViewApiClient.createTag(request)
                .then((response: CreateTagResponse) => {
                    if (response.success) {
                        this.snackBar.open(`Added tag!`, 'OK', { duration: 2000 });
                        //this.router.navigate(['admin/release', response.releaseId]);
                        this.loadData();
                    } else {
                        this.snackBar.open(`Error adding tag!`, 'OK', { duration: 2000 });
                    }
                })
                .catch((err: any) => {
                    this.snackBar.open(`Error adding tag!`, 'OK', { duration: 2000 });
                });
        }
    }));
  }

  private updateParams() {
    const queryParams: { [key: string]: any } = {};

    if (this.searchTerm) {
      queryParams.search = this.searchTerm;
    }
    if (this.resourceTypeFilter !== undefined) {
      //queryParams.released = this.ReleasedParamName;
    }

    const urlTree = this.router.createUrlTree([], {
      queryParamsHandling: "merge",
      preserveFragment: true,
      queryParams: queryParams
    });

    if (!this.searchTerm) {
      delete urlTree.queryParams[this.SearchParamName];
    }
    if (this.resourceTypeFilter === undefined) {
      //delete urlTree.queryParams[this.ReleasedParamName];
    }
  
    this.router.navigateByUrl(urlTree);
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}